<template>
  <ElSwitch class="x-admin-switcher"
            :width="80"
            v-bind="$attrs"
            v-on="$listeners"
            active-color="#1989fa"
            inactive-color="#1989fa"
            active-icon-class="el-icon-star-off"
            inactive-icon-class="el-icon-menu"></ElSwitch>
</template>

<script>
import { Switch as ElSwitch } from 'element-ui';

export default {
  inheritAttrs: false,
  components: {
    ElSwitch
  }
};
</script>
